import { renderSafeMarkdown } from '../../lib/safeMarkdownHtml';

type SafeMarkdownContentProps = {
  markdown: string;
  className?: string;
  /** When false, markdown links render as plain text (blog / public surfaces). Default true. */
  allowLinks?: boolean;
};

const baseClass =
  'safe-markdown leading-relaxed text-[length:var(--sf-font-size-base,1rem)] text-[var(--text-primary)] [&_strong]:font-semibold [&_em]:italic [&_s]:line-through [&_ul]:my-1 [&_ol]:my-1';

/** Renders a safe markdown subset (bold, italic, headings, optional links, lists). */
export function SafeMarkdownContent({
  markdown,
  className = '',
  allowLinks = true,
}: SafeMarkdownContentProps) {
  return (
    <div
      className={`${baseClass} ${className}`.trim()}
      dangerouslySetInnerHTML={{ __html: renderSafeMarkdown(markdown, { allowLinks }) }}
    />
  );
}
